export function LoadingSpinner({ label = 'Loading…' }) {
  return (
    <div className="center" style={{ padding: 'var(--space-12)' }} role="status">
      <div className="spinner" aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </div>
  );
}

export function InlineSpinner() {
  return <span className="spinner" style={{ width: 16, height: 16, borderWidth: 2 }} aria-hidden="true" />;
}
